import { Box, makeStyles, Typography } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme) => ({
  mainBox: {
    textAlign: "center",
    marginTop: 15,
    "& h6": {
      background: theme.palette.background.dark1,
      color: theme.palette.text.black,
    },
  },
}));
export default function NoDataFound() {
  const classes = useStyles();
  return (
    <Box className={classes.mainBox}>
      <Typography variant='h6' style={{ fontSize: "12px", fontWeight: "100" }}>
        No Data Found
      </Typography>
    </Box>
  );
}
